import * as yup from "yup";

export const vacancySchema = yup.object().shape({
  name: yup.string().required("Campo obrigatório"),
  model: yup.string().required("Campo obrigatório"),
  type: yup.string().required("Campo obrigatório"),
  location: yup.string().required("Campo obrigatório"),
  vacancy_link: yup.string().required("Campo obrigatório"),
});
